/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
class SettingsService extends __BaseService {
  static readonly settingsUpdateSettingPath =
    "/api/admin/Settings/UpdateSetting";
  static readonly settingsGetSettingPath =
    "/api/admin/Settings/GetSetting/{name}";
  static readonly settingsGetSideNavigationPath =
    "/api/admin/Settings/GetSideNavigation";
  static readonly settingsSetSideNavigationPath =
    "/api/admin/Settings/SetSideNavigation";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param params The `SettingsService.SettingsUpdateSettingParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `name`:
   */
  settingsUpdateSettingResponse(
    params: SettingsService.SettingsUpdateSettingParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.upload != null) {
      __formData.append("upload", params.upload as string | Blob);
    }
    if (params.name != null) {
      __formData.append("name", params.name as string | Blob);
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/Settings/UpdateSetting`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SettingsService.SettingsUpdateSettingParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `name`:
   */
  settingsUpdateSetting(
    params: SettingsService.SettingsUpdateSettingParams
  ): __Observable<Blob> {
    return this.settingsUpdateSettingResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param name undefined
   */
  settingsGetSettingResponse(
    name: string
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/Settings/GetSetting/${name}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param name undefined
   */
  settingsGetSetting(name: string): __Observable<string> {
    return this.settingsGetSettingResponse(name).pipe(
      __map((_r) => _r.body as string)
    );
  }
  settingsGetSideNavigationResponse(): __Observable<
    __StrictHttpResponse<boolean>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/Settings/GetSideNavigation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  settingsGetSideNavigation(): __Observable<boolean> {
    return this.settingsGetSideNavigationResponse().pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param sideNavigationEnabled undefined
   */
  settingsSetSideNavigationResponse(
    sideNavigationEnabled?: boolean
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (sideNavigationEnabled != null)
      __params = __params.set(
        "sideNavigationEnabled",
        sideNavigationEnabled.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/Settings/SetSideNavigation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param sideNavigationEnabled undefined
   */
  settingsSetSideNavigation(
    sideNavigationEnabled?: boolean
  ): __Observable<Blob> {
    return this.settingsSetSideNavigationResponse(sideNavigationEnabled).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
}

module SettingsService {
  /**
   * Parameters for SettingsUpdateSetting
   */
  export interface SettingsUpdateSettingParams {
    upload?: null | Blob;
    name?: null | string;
  }
}

export { SettingsService };
